import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { AuthService } from '../services/auth.service'

export const authGuard: CanActivateFn = (route) => {
  const authService = inject(AuthService)
  const router = inject(Router)
  const requiredRole = route.data?.['role'] as string | string[] | undefined
  const requiredRoles = Array.isArray(requiredRole)
    ? requiredRole
    : requiredRole ? [requiredRole] : []
  const isManagementRoute = requiredRoles.some(role =>
    role === 'admin' || role === 'super-admin' || role === 'seller'
  )
  const user = isManagementRoute
    ? authService.getStoredUser('admin')
    : authService.getStoredUser('user')

  if (!user) {
    router.navigate([isManagementRoute ? '/admin-login' : '/login'])
    return false
  }

  const currentRole = user.role
  const roleAllowed = Array.isArray(requiredRole)
    ? requiredRole.includes(currentRole || '')
    : !requiredRole || currentRole === requiredRole

  if (!roleAllowed) {
    router.navigate(['/'])
    return false
  }

  return true
}
